<template>
  <div class="metafield-edit-repeater">
    <slot name="toggleBtn"></slot>
    <div class="metafield-edit-repeater__wrapper">
      <p class="metafield-edit-repeater__name">{{ groupName }}</p>
      <TypographyInputHint v-if="hint">{{ hint }}</TypographyInputHint>
      <TypographyInputHint v-if="warning" :isDanger="true">{{ warning }}</TypographyInputHint>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupName: String,
    hint: String,
    warning: String
  }
}
</script>

<style lang="scss">
  @import './src/assets/styles/mixins.scss';

  .metafield-edit-repeater {
    padding: 0;

    &__wrapper {
      padding: 20px 20px 20px 0;
    }

    &__name {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditRepeater.vue